import { BaseLoggerClass } from './baseLogger';
import { eventLogger, EventLoggerClass } from './EventLogger';
import { logger, LoggerClass } from './logger';

export type { TrafficSource } from './type';

export { eventLogger, EventLoggerClass, logger, LoggerClass };
export default BaseLoggerClass;
